import type { ForwardedRef } from 'react';
import { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  keyword: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const NewViewModelTagInputFn = ({ keyword, onChange }: Props, forwardedRef: ForwardedRef<HTMLInputElement>) => {
  const { t } = useTranslation();
  // サイドバーのビューモデル検索機能からビューモデルに移動した後に、モデル要素のコピー&ペーストが行えない問題に対処するための処置。
  // 検索テキストボックスのフォーカスが外れているにも関わらず、ペーストイベントの対象が input になるため、モデル要素の貼り付け処理がスキップされていた。
  // 検索ボックスに対してフォーカス状態に連動する data-focus 属性を付与することで、ペーストイベントの対象を判別できるようにする。
  // https://www.notion.so/levii/5f46f11283a64584be7cb5ccb51b8373
  const [focus, onFocus] = useState(false);

  return (
    <input
      value={keyword}
      onChange={onChange}
      onFocus={() => onFocus(true)}
      onBlur={() => onFocus(false)}
      data-focus={focus}
      type="text"
      className="min-w-0 flex-1 rounded-l-md bg-gray-200 py-1 pr-2 placeholder:text-sm focus:outline-none"
      placeholder={t('viewModel.tag.searchInput.placeholder')}
      style={{ paddingInlineStart: '24px' }}
      ref={forwardedRef}
    />
  );
};

// TODO: React 19になったらforwardRefは不要（非推奨）
export const NewViewModelTagInput = forwardRef<HTMLInputElement, Props>(NewViewModelTagInputFn);
